const axios = require('axios')
const config = require('./config')

const defaults = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-organisation-id': '8f5a7802-976f-4cf1-ba77-8d84be8f9e9d'
  },
  json: true
}

defaults.baseURL =
  config.default.environment[process.env.NODE_ENV || 'development'].apiUrl

export default axios.create(defaults)
